import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	sectionLabel: {
		id: 'custom-sites-extensions.link-cards.card.image.section.label',
		defaultMessage: 'Image',
		description: 'Visible label for the section of the card for handling image',
	},
});
